var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('AppTitle',[_vm._v("угадывай тексты")]),_c('AppTitle',[_vm._v("песен и выигрывай")]),_c('AppTitle',[_vm._v("призы от Мегафона")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }